import type { ReactNode } from 'react';

export interface EmptyStateAction {
  label: string;
  onClick?: () => void;
  href?: string;
  testId?: string;
}

export interface EmptyStateProps {
  icon: ReactNode;
  title: string;
  description?: string;
  action?: EmptyStateAction;
  variant?: 'card' | 'inline';
  testId?: string;
}

export function EmptyState({
  icon,
  title,
  description,
  action,
  variant = 'card',
  testId,
}: EmptyStateProps) {
  const className =
    variant === 'inline' ? 'empty-state empty-state--inline' : 'empty-state empty-state--card';
  return (
    <div className={className} data-testid={testId} data-variant={variant}>
      <span className="empty-state__icon" aria-hidden="true">
        {icon}
      </span>
      <div className="empty-state__body">
        <p className="empty-state__title">{title}</p>
        {description ? <p className="empty-state__description">{description}</p> : null}
      </div>
      {action ? (
        action.href ? (
          <a
            className="btn-primary empty-state__action"
            href={action.href}
            data-testid={action.testId}
          >
            {action.label}
          </a>
        ) : (
          <button
            type="button"
            className="btn-primary empty-state__action"
            onClick={action.onClick}
            data-testid={action.testId}
          >
            {action.label}
          </button>
        )
      ) : null}
    </div>
  );
}
